<template>
  <div v-loading="loading">
    <el-table
      border
      :key="scale.id"
      size="mini"
      :data="scale.options"
    >
      <el-table-column width="150" prop="score" label="Оценка">
        <template v-slot="scope">
          <span>{{ scope.row.score == 0 ? 'Затрудняюсь ответить' : scope.row.score }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="Значение">
        <template v-slot="scope">
          <click-to-edit
            v-model="scope.row.value"
            :word-limit="1000"
            style="width: 100%"
            @input="updateOption(scope.row)"
          ></click-to-edit>
        </template>
      </el-table-column>

      <el-table-column width="45" align="right">
        <template v-slot="scope">
          <el-popconfirm
            v-if="scope.row.score != 0"
            style="float:left"
            confirm-button-text='Да'
            cancel-button-text='Нет'
            icon="el-icon-question"
            title="Вы уверены, что хотите удалить оценку?"
            @confirm="deleteOption(scope.row)"
          >
            <el-button
              slot="reference"
              class="table-action-button"
              size="mini"
              round
              icon="far fa-trash-alt"
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-button
      type="text"
      size="mini"
      icon="fas fa-plus"
      @click="createOption"
    >
      Создать оценку
    </el-button>

    <el-switch
      style="margin-left: 30px"
      v-model="scale.has_unsure_option"
      :active-value="true"
      :inactive-value="false"
      active-text="Добавить вариант Затрудняюсь ответить"
      @change="$emit('update-scale')"
    >
    </el-switch>
  </div>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "options-component",
  components: { ClickToEdit },
  props: {
    scale: { type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api.evaluation.optionSearch({
        scale_id: this.scale.id,
      })
        .then(({data}) => {
          this.$set(this.scale, 'options', data.options);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    updateOption(scope) {
      this.loading = true;
      this.$api.evaluation.optionUpdate({
        id: scope.id,
        value: scope.value ?? null,
      })
        .then(data => {
          this.$notify.success({
            title: 'Обновлено',
            message: 'Оценка успешно обновлена'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    createOption() {
      this.loading = true;
      this.$api.evaluation.optionCreate({
        scale_id: this.scale.id,
      })
        .then(data => {
          this.getOptions();
          this.$notify.success({
            title: 'Сохранено',
            message: 'Оценка успешно создана'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    deleteOption(scope) {
      this.loading = true;
      this.$api.evaluation.optionDelete({
        ids: [scope.id],
      })
        .then(data => {
          this.getOptions();
          this.$notify.success({
            title: 'Удалено',
            message: 'Оценка успешно удалена'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
  }
}
</script>

<style scoped>

</style>